import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "calendar_filled",
  width: "40",
  height: "40",
  viewBox: "0 0 19.5 19.5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_2476",
  d: "M20.25 3.75H18v-1.5h-1.5v1.5h-9v-1.5H6v1.5H3.75a1.5 1.5 0 0 0-1.5 1.5V9h19.5V5.25a1.5 1.5 0 0 0-1.5-1.5z",
  class: "cls-1",
  transform: "translate(-2.25 -2.25)"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_2477",
  d: "M8.25 12.75h2.25v6.75H9v-5.25h-.75zm3.75 1.5v-1.5h4.5v1.5l-2.812 5.25H12l2.8-5.25zm-9.75 6a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V10.5H2.25z",
  class: "cls-1",
  transform: "translate(-2.25 -2.25)"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render };